import Bowser from 'bowser';
import { useMemo } from 'react';

export const useBowser = () => {
  const parser = useMemo(
    () => Bowser.getParser(window.navigator.userAgent),
    [],
  );

  const isMobile = useMemo(
    () => parser.getPlatform().type === 'mobile',
    [parser],
  );
  const isDesktop = useMemo(
    () => parser.getPlatform().type === 'desktop',
    [parser],
  );

  return { isMobile, isDesktop };
};
